/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatMessageData } from './chatMessageData';


export interface MessageViewDto { 
    _id: string;
    messageType: MessageViewDto.MessageTypeEnum;
    time: string;
    chatId: string;
    sentBy: string;
    messageData: ChatMessageData;
    displayName: string;
    readByUserIds: Array<string>;
    avatarUrl?: string;
    reactions?: Array<{ userId: string; emoji: string }>;
    replyToId?: string;
    replyTo?: { _id: string; sentBy: string; displayName: string; messageType: string; text: string; removed: boolean };
}
export namespace MessageViewDto {
    export type MessageTypeEnum = 'text' | 'image' | 'document' | 'voice' | 'video' | 'outing';
    export const MessageTypeEnum = {
        Text: 'text' as MessageTypeEnum,
        Image: 'image' as MessageTypeEnum,
        Document: 'document' as MessageTypeEnum,
        Voice: 'voice' as MessageTypeEnum,
        Video: 'video' as MessageTypeEnum,
        Outing: 'outing' as MessageTypeEnum
    };
}


